const COLORS = {
  primary: "#1f3a70",
  primaryLight: "#3d5bb8",
  text: "#15233c",
  textLight: "#5d6f8a",
  textMuted: "#334155",
  error: "#b91c1c",
  errorBg: "rgba(248, 113, 113, 0.12)",
  border: "#cbd5e1",
  background: "#ffffff",
  bgLight: "#f8fafc",
  shadow: "rgba(15, 23, 42, 0.12)",
  focusShadow: "rgba(31, 58, 112, 0.08)",
};

export const styles = {
  page: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    height: "100vh",
    padding: 24,
    boxSizing: "border-box",
    overflow: "hidden",
    backgroundImage: `linear-gradient(rgba(255,255,255,0.86), rgba(255,255,255,0.86)), url('/login-background.png')`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
  card: {
    width: 460,
    maxWidth: "100%",
    background: COLORS.background,
    borderRadius: 30,
    boxShadow: `0 24px 80px ${COLORS.shadow}`,
    padding: 40,
    border: `1px solid rgba(203, 213, 225, 0.55)`,
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
  },
  brandRow: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    marginBottom: 28,
    justifyContent: "center",
  },
  logo: {
    width: 72,
    height: 72,
    objectFit: "contain",
  },
  brandText: {
    display: "flex",
    flexDirection: "column",
    lineHeight: 1.1,
  },
  brandTitle: {
    fontSize: 26,
    fontWeight: 800,
    color: COLORS.text,
  },
  brandSubtitle: {
    fontSize: 16,
    fontWeight: 600,
    color: COLORS.primary,
  },
  inputWrapper: {
    position: "relative",
    width: "100%",
    display: "flex",
    alignItems: "center",
  },
  inputIcon: {
    position: "absolute",
    left: 16,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 24,
    height: 24,
    color: COLORS.primary,
    pointerEvents: "none",
  },
  inputWithIcon: {
    width: "100%",
    minHeight: 48,
    padding: "12px 16px 12px 44px",
    borderRadius: 16,
    border: `1px solid ${COLORS.border}`,
    background: COLORS.bgLight,
    color: "#0f172a",
    fontSize: 15,
    outline: "none",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    boxSizing: "border-box",
  },
  title: {
    margin: 0,
    marginBottom: 8,
    fontSize: 32,
    color: COLORS.text,
    letterSpacing: "0.5px",
    textAlign: "center",
  },
  subtitle: {
    margin: 0,
    marginBottom: 28,
    color: COLORS.textLight,
    fontSize: 15,
    textAlign: "center",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    marginBottom: 18,
    width: "100%",
  },
  label: {
    fontSize: 14,
    fontWeight: 600,
    color: COLORS.textMuted,
  },
  input: {
    width: "100%",
    minHeight: 48,
    padding: "12px 16px",
    borderRadius: 16,
    border: `1px solid ${COLORS.border}`,
    background: COLORS.bgLight,
    color: "#0f172a",
    fontSize: 15,
    outline: "none",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    boxSizing: "border-box",
  },
  inputFocus: {
    borderColor: COLORS.primary,
    boxShadow: `0 0 0 4px ${COLORS.focusShadow}`,
  },
  button: {
    width: "100%",
    minHeight: 50,
    borderRadius: 16,
    border: "none",
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, ${COLORS.primaryLight} 100%)`,
    color: COLORS.background,
    fontSize: 16,
    fontWeight: 700,
    cursor: "pointer",
    opacity: 1,
    transition: "transform 0.2s ease, opacity 0.2s ease, background 0.2s ease",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
  },
  buttonDisabled: {
    cursor: "not-allowed",
    opacity: 0.9,
  },
  spinner: {
    width: 18,
    height: 18,
    border: "3px solid rgba(255,255,255,0.35)",
    borderTopColor: COLORS.background,
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  error: {
    color: COLORS.error,
    background: COLORS.errorBg,
    borderRadius: 14,
    padding: "12px 14px",
    marginBottom: 18,
    fontSize: 14,
    width: "100%",
    boxSizing: "border-box",
    textAlign: "center",
  },
  passwordContainer: {
    position: "relative",
    width: "100%",
    display: "flex",
    alignItems: "center",
  },
  passwordInput: {
    width: "100%",
    minHeight: 44,
    padding: "10px 14px 10px 14px",
    paddingRight: 44,
    borderRadius: 12,
    border: `1px solid ${COLORS.border}`,
    background: COLORS.bgLight,
    color: "#0f172a",
    fontSize: 15,
    outline: "none",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    boxSizing: "border-box",
  },
  eyeIcon: {
    position: "absolute",
    right: 12,
    cursor: "pointer",
    fontSize: 20,
    color: COLORS.textMuted,
    userSelect: "none",
    transition: "color 0.2s ease",
  },
  eyeIconHover: {
    color: COLORS.primary,
  },

  eyeButton: {
  position: "absolute",
  right: 12,
  top: "50%",
  transform: "translateY(-50%)",
  background: "transparent",
  border: "none",
  padding: 0,
  margin: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  color: COLORS.textMuted,
},
};
